import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { ReviewTranslationStateModel } from 'models/common/review-types';

export const ReviewTranslateLabel: React.FunctionComponent<ReviewTranslationStateModel> = props => {
  const { reviewTranslationState } = props;

  if (reviewTranslationState === 'translated') {
    const translatedbyGoogleLabelText = <LocalizedText message="hotels.infosite.reviews.translate.translatedby.text" />;
    const googleLabel = <LocalizedText message="hotels.infosite.reviews.translate.google.text" />;

    return (
      <span className="uitk-type-200 pwa-theme--grey-700 all-b-margin-two">
        {' '}
        {translatedbyGoogleLabelText}
        <span className="uitk-type-bold all-r-margin-two all-l-margin-one">{googleLabel}</span>
      </span>
    );
  }

  return null;
};
